
export default function Filter({records,downloadExcel,downloadPDF}) {
  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {records}
        </button>
      </div>
      <div className="filterright">
        <button
          onClick={downloadExcel}
          className={"NavLinkBtn hover marginright unselectlink"}
        >
          EXCEL
        </button>
        <button
          onClick={downloadPDF}
          className={"NavLinkBtn hover marginright unselectlink"}
        >
          PDF
        </button>
      </div>
    </div>
  );
}
